import { ChangeDetectorRef, Component, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SharedService } from '../../shared.service';
import { EncryptionService } from '../../../services/encryption.service';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-gdc-sidebar',
    imports: [NgClass, RouterLink],
    templateUrl: './gdc-sidebar.component.html',
    styleUrl: './gdc-sidebar.component.scss',})
export class GdcSidebarComponent {
  title = 'vas-project';
  isExpanded: boolean = false;   // For expanded layout
  isMobile: boolean = false;
  isMobileView: boolean = false;
  isvasSidebar: boolean = true;
  Userrole: any = this.encryptionService.getFromLocalStorage('user_type');
  username: string | null = '';
  userType: string | null = '';
  isCollapse: boolean = false;

  MENUITEMS: any[] = [
    {
      title: 'Pipeline',
      icon: 'ti-layout-sidebar',
      type: 'sub',
      imgpath: '/assets/img/Pipeline.svg',
      active: false,
      User: 'both',
      children: [
        { path: '/tml/pipeline/A0', title: 'A0-Enquiry', type: 'link', active: false },
        { path: '/tml/pipeline/A1', title: 'A1-Pre-Order', type: 'link', active: false },
        { path: '/tml/pipeline/A2', title: 'A2-KYC Verification', type: 'link', active: false },
        { path: '/tml/pipeline/A3', title: 'A3-Payments', type: 'link', active: false },
        { path: '/tml/pipeline/A4', title: 'A4-CIF Acceptance', type: 'link', active: false },
        { path: '/tml/pipeline/cancel', title: 'Cancelled Order', type: 'link', active: false },
        { path: '/tml/pipeline/lost', title: 'Lost Opty', type: 'link', active: false },
      ],
    },
    {
      title: 'My Actions',
      icon: 'ti-layout-sidebar',
      type: 'sub',
      imgpath: '/assets/img/Pipeline.svg',
      active: false,
      User: 'both',
      isOpen: true,
      children: [],
    },
    {
      title: 'My Approvals',
      icon: 'ti-layout-sidebar',
      type: 'sub',
      imgpath: '/assets/img/Pipeline.svg',
      active: false,
      User: 'both',
      isOpen: true,
      children: [],
    },
    {
      title: 'Report',
      icon: 'ti-smart-home',
      type: 'sub',
      imgpath: '/assets/img/Vector.svg',
      active: false,
      User: '',
      isOpen: true,
      children: [
        { path: '/tml/reports/pipeline-reports', title: 'Pipeline Report', type: 'link', active: false },
        { path: '/tml/reports/workbench', title: 'Workbench', type: 'link', active: false },
        { path: '/tml/reports/error-log', title: 'Error Logs', type: 'link', active: false }
      ]
    },
    {
      path: '/tml/vas-history',
      title: 'Contracts History',
      icon: 'ti-smart-home',
      imgpath: '/assets/img/Vector.svg',
      type: 'link',
      active: false,
      User: '',
    },
    // { path: '/tml/faq', title: 'FAQ', icon: 'ti-help', imgpath: '/assets/img/Help.svg', type: 'link', active: false, User: '' }
  ];

  constructor(
    private sharedService: SharedService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private encryptionService: EncryptionService
  ) {
    const positionType = this.encryptionService.getFromLocalStorage('position_type');
    let userType = this.encryptionService.getFromLocalStorage('user_type');

    // Call the function to dynamically assign menus based on position type
    if (positionType) {
      this.addRoleBasedMenus(positionType, userType);
    }
  }

  addRoleBasedMenus(role: string, userType: any) {
    const actionItems = [];
    const approvalItems = [];
    if (String(userType).toLowerCase() === 'approver') {
      this.MENUITEMS = [
        {
          path: '/tml/price-deviation/pending',
          title: 'Price Deviation',
          icon: 'ti-layout-sidebar',
          imgpath: '/assets/img/Pipeline.svg',
          type: 'link',
          active: false,
          User: 'both',
        },
        {
          title: 'Reports',
          icon: 'ti-smart-home',
          type: 'sub',
          imgpath: '/assets/img/Pipeline.svg',
          active: false,
          User: 'both',
          isOpen: true,
          children: [
            { path: '/tml/price-deviation', title: 'Price Deviation', type: 'link', active: false }
          ],
        },
      ];
    } else {
      if (role === 'GDC_AMC_MDM') {
        actionItems.push(
          { path: '/tml/actions/list/A2', title: 'Create Customer', type: 'link', active: false },
          { path: '/tml/actions/sap-posting', title: 'SAP Transaction', type: 'link', active: false }
        );
        approvalItems.push({ path: '/tml/approval/A2', title: 'Customer Code', type: 'link', active: false });
      }
      if (role === 'GDC_AMC_BOOKING') {
        actionItems.push(
          { path: '/tml/actions/list/A4', title: 'CIF Verification', type: 'link', active: false }
        );
        approvalItems.push({ path: '/tml/approval/A4', title: 'Verified CIF', type: 'link', active: false });
      }
      if (role === 'GDC_AMC_FIN') {
        actionItems.push(
          { path: '/tml/actions/list/pdc', title: 'PDC Verification', type: 'link', active: false },
          { path: '/tml/actions/list/mandate', title: 'Mandate Verification', type: 'link', active: false },
          { path: '/tml/actions/sap-posting', title: 'SAP Transaction', type: 'link', active: false }
        );
        approvalItems.push({ path: '/tml/approval/A3', title: 'Verified Payment', type: 'link', active: false });
      }

      if (role === 'GDC_AMC_LEAD') {
        actionItems.push(
          { path: '/tml/actions/list/A2', title: 'A2-KYC Verification', type: 'link', active: false },
          { path: '/tml/actions/list/A3', title: 'A3-Payments', type: 'link', active: false },
          { path: '/tml/actions/list/A4', title: 'A4-CIF Acceptance', type: 'link', active: false },
          { path: '/tml/actions/list/pdc', title: 'PDC Verification', type: 'link', active: false },
          { path: '/tml/actions/list/mandate', title: 'Mandate Verification', type: 'link', active: false },
          { path: '/tml/actions/sap-posting', title: 'SAP Transaction', type: 'link', active: false }
        );
        approvalItems.push(
          { path: '/tml/approval/A2', title: 'A2-KYC Verification', type: 'link', active: false },
          { path: '/tml/approval/A3', title: 'A3-Payments', type: 'link', active: false },
          { path: '/tml/approval/A4', title: 'A4-CIF Acceptance', type: 'link', active: false }
        );
      }

      // Dynamically update My Actions and My Approvals menu
      const actionsMenu = this.MENUITEMS.find((item) => item.title === 'My Actions');
      if (actionsMenu) actionsMenu.children = actionItems;

      const approvalsMenu = this.MENUITEMS.find((item) => item.title === 'My Approvals');
      if (approvalsMenu) approvalsMenu.children = approvalItems;
    }
  }

  ngOnInit() {
    this.isCollapse = JSON.parse(localStorage.getItem('isCollasepedflag') || 'false');
    this.sharedService.toggleSidebar$.subscribe((value: boolean) => {
      this.isCollapse = value;
    });
    this.username = this.encryptionService.getFromLocalStorage('username');
    this.userType = this.encryptionService.getFromLocalStorage('user_type');

    this.detectMobileView(false);
    const matchUrl = ["/tml/order", "/tml/actions"];
    this.getOrdermatchUrl(matchUrl, this.router.url);

    if (matchUrl.some(url => this.router.url.includes(url))) {
      this.isvasSidebar = true;
    } else {
      this.isvasSidebar = false;
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getOrdermatchUrl(matchUrl, this.router.url);
      }
    });
    this.setActivePath(this.router.url);

    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
    this.getIsorderOpen(matchUrl, this.router.url);
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.setActivePath(event.urlAfterRedirects);
      }
    });
  }

  ngDocheck() {
    this.detectMobileView(false);
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
  }

  setActivePath(pathToActivate: string) {
    const activePath = pathToActivate.split('?')[0].replace(/\/$/, '') || '/';
    this.MENUITEMS.forEach((item: any) => {
      let parentActive = false;

      if (item?.children) {
        item.children.forEach((child: any) => {
          if (child.path === activePath) {
            child.active = true;
            parentActive = true;
          } else {
            child.active = false;
          }
        });
      }

      if (parentActive) {
        item.active = true;
      } else if (item.path === activePath) {
        item.active = true;
      } else {
        item.active = false;
      }
    });
  }

  detectMobileView(val: boolean) {
    this.isMobile = val;
    this.isMobileView = window.innerWidth <= 768;
    this.sharedService.toggleClass(val);
  }

  getActivemenu(item: any): any {
    item.isOpen = !item.isOpen;
  }

  navigateTo(path: string, parent: any, child: any, event: Event): void {
    this.MENUITEMS?.forEach(menuItem => {
      menuItem.active = false;
      if (menuItem?.children) {
        menuItem.children.forEach((childItem: any) => childItem.active = false);
      }
    });

    event.stopPropagation();
    parent?.children?.forEach((childItem: any) => childItem.active = false);
    child.active = true;
    parent.active = true;

    this.router.navigate([path]);
  }

  getActiveChild(parent: any, child: any, event: Event) {
    this.MENUITEMS?.forEach(menuItem => {
      menuItem.active = false;
      if (menuItem?.children) {
        menuItem.children.forEach((childItem: any) => childItem.active = false);
      }
    });

    event.stopPropagation();
    parent?.children?.forEach((childItem: any) => childItem.active = false);
    child.active = true;
    parent.active = true;
  }

  getIsorderOpen(matchUrl: any, mainUrl: any): any {
    this.sharedService.toggleVasCreateOrder$.subscribe((value: boolean) => {
      if (mainUrl.includes(matchUrl)) {
        this.isvasSidebar = true;
      } else {
        this.isvasSidebar = value;
      }
    });
  }

  getOrdermatchUrl(matchUrl: any, mainUrl: any): any {
    if (mainUrl.includes(matchUrl)) {
      this.isvasSidebar = true;
    } else {
      this.isvasSidebar = false;
    }
    this.cdr.detectChanges();
  }
}
